import { render, staticRenderFns } from "./itemC.vue?vue&type=template&id=86f55cb4&scoped=true&"
import script from "./itemC.vue?vue&type=script&lang=js&"
export * from "./itemC.vue?vue&type=script&lang=js&"
import style0 from "./itemC.vue?vue&type=style&index=0&id=86f55cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f55cb4",
  null
  
)

export default component.exports